// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bx1T","footer":"styles_footer__35XFU"};